/**
 * Opt-in "Remember this result on this device". Stores only the stable hash and a timestamp,
 * never raw signals. Nothing is written unless the user ticks the box; unticking deletes it.
 */
const KEY = 'fingerprint-check:remembered';

export interface Saved {
  hash: string;
  savedAt: string;
}

export function loadSaved(): Saved | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Saved>;
    return typeof parsed.hash === 'string' && typeof parsed.savedAt === 'string' ? { hash: parsed.hash, savedAt: parsed.savedAt } : null;
  } catch {
    return null;
  }
}

export function save(hash: string): Saved | null {
  const saved: Saved = { hash, savedAt: new Date().toISOString() };
  try {
    localStorage.setItem(KEY, JSON.stringify(saved));
    return saved;
  } catch {
    return null;
  }
}

export function forget(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable: nothing was stored */
  }
}

export const formatSavedDate = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
};
